import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from './AuthReducer';
import userReducer from './UserReducer';
import criteriaManagementGroupReducer from './CriteriaManagementGroupReducer';
import BuyerGroupReducer from '../views/RulesEngine/Pages/Buyer/BuyerGroup/BuyerGroupReducers';
import SplitScenarioReducer from '../views/RulesEngine/Pages/Buyer/SplitScenario/SplitScenarioReducers';
import buyerActivityReducer from '../views/RulesEngine/Pages/Buyer/BuyerActivitySummary/BuyerActivitySummaryReducers';
import SplitSettingsReducer from '../views/RulesEngine/Pages/Buyer/BuyerSplitSettings/SplitSettingReducers';
import CurrentLenderReducer from '../views/RulesEngine/Pages/Lender/CurrentLenders/CurrentLenderReducers';
import TCPAReducer from '../views/RulesEngine/Pages/Buyer/TCPA/TCPAReducers';
import DisclosureReducer from '../views/RulesEngine/Pages/Buyer/Disclosure/DisclosureReducers';
import VetsuRedirectState from '../views/RulesEngine/Pages/Vetsu/VetsuRedirect/VetsuRedirectReducers';
import PersonalLoanRedirectReducer from '../views/RulesEngine/Pages/Loans/PersonalLoanRedirect/Reducers';
import AdvertiserLegalReducer from '../views/RulesEngine/Pages/Buyer/AdvertiserLegal/AdvertiserLegalReducers';
import ThankYouPageReducer from '../views/RulesEngine/Pages/Buyer/ThankYouPage/ThankYouPageReducers';
import verticalReducer from './VerticalReducer';
import ConsumerPrivacyReducers from '../views/RulesEngine/Pages/Buyer/ConsumerPrivacy/ConsumerPrivacyReducers';
import BuyerCakeScheduleReducers from '../views/RulesEngine/Pages/Buyer/BuyerCakeSchedule/BuyerCakeScheduleReducers';

export default combineReducers({
  form: formReducer,
  auth: authReducer,
  user: userReducer,
  BuyerGroup: BuyerGroupReducer,
  SplitScenario: SplitScenarioReducer,
  buyerActivity: buyerActivityReducer,
  buyerSplitSettings: SplitSettingsReducer,
  currentLenders: CurrentLenderReducer,
  tcpa: TCPAReducer,
  disclosure: DisclosureReducer,
  vetsURedirect: VetsuRedirectState,
  personalLoanRedirect: PersonalLoanRedirectReducer,
  advertiserLegal: AdvertiserLegalReducer,
  thankYouPage: ThankYouPageReducer,
  criteriaManagementGroup: criteriaManagementGroupReducer,
  vertical: verticalReducer,
  ConsumerPrivacy: ConsumerPrivacyReducers,
  BuyerCakeSchedule: BuyerCakeScheduleReducers,
});
